import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataTableColumn } from '../../../../shared/ui/data-table/data-table.component';
import { Errors, FileService, LocalService, SellerService, formatDate } from '../../../../core';
import { sellerApi } from '../../../../config';

@Component({
  selector: 'app-reward-points-tab',
  templateUrl: './reward-points-tab.component.html',
  styleUrls: ['./reward-points-tab.component.scss'],
})
export class RewardPointsTabComponent implements OnInit {
  private userProfile: any;
  errors: Errors = { errors: {} };

  pthDateForm: FormGroup = null as any;

  pageNo = 0;
  size = 5;
  sortBy: any;
  startDate: any;
  endDate: any;
  minDate: any;
  maxDate: any;

  isLoading: boolean = false;
  pointTransactionHistory: any;
  pointsPage: number = 1;

  pointsTableColumns: DataTableColumn[] = [
    { field: 'date', header: 'Activity Date', align: 'center' },
    { field: 'pointsEarned', header: 'Total Points Recived', align: 'center', highlight: 'green' },
    { field: 'pointsRedeemed', header: 'Total Points Redeemed', align: 'center', highlight: 'orange' },
    { field: 'currentBalance', header: 'Availabe Points', align: 'center', isBold: true },
    { field: 'status', header: 'Status', align: 'center' },
  ];

  get pointsRows() {
    const content = this.pointTransactionHistory && this.pointTransactionHistory.content
      ? this.pointTransactionHistory.content : [];
    return content.map((item: any) => ({
      ...item,
      date: item.date ? new Date(item.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '-',
      pointsEarned: item.pointsEarned != null ? item.pointsEarned.toLocaleString('en-US') : '-',
      pointsRedeemed: item.pointsRedeemed != null ? item.pointsRedeemed.toLocaleString('en-US') : '-',
      currentBalance: item.currentBalance != null ? item.currentBalance.toLocaleString('en-US') : '-',
    }));
  }

  constructor(
    private sellerService: SellerService,
    private formBuilder: FormBuilder,
    private fileService: FileService,
  ) {}

  ngOnInit() {
    this.userProfile = LocalService.get('userProfile');
    this.generateFormPoints();
    this.getpointTransactionHistory({ pageSize: this.size, pageIndex: this.pageNo });
  }

  generateFormPoints() {
    this.pthDateForm = <FormGroup>this.formBuilder.group(
      {
        startDate: ['', [Validators.required]],
        completeBy: ['', [Validators.required]],
      },
      this.checkDates.bind(this)
    );
  }

  checkDates(group: FormGroup): { notValid: boolean } | null {
    if (
      group.controls.startDate.value &&
      group.controls.completeBy.value &&
      group.controls.completeBy.value < group.controls.startDate.value
    ) {
      return { notValid: true };
    }
    return null;
  }

  searchByNamePoints() {
    Object.keys(this.pthDateForm.controls).forEach((key: string) => {
      const control = this.pthDateForm.get(key);
      if (control) {
        control.markAsTouched();
      }
    });
    if (this.pthDateForm.valid) {
      this.startDate = formatDate(this.pthDateForm.controls.startDate.value, 'YYYY-MM-DD HH:mm:ss');
      this.endDate = formatDate(this.pthDateForm.controls.completeBy.value, 'YYYY-MM-DD HH:mm:ss');
      this.getpointTransactionHistoryBySearch(this.startDate, this.endDate);
    }
  }

  getpointTransactionHistoryBySearch(startDate?: any, endDate?: any) {
    this.pageNo = 0;
    const params: any = {
      page: this.pageNo,
      size: this.size,
      userIds: this.userProfile.id,
    };
    if (startDate && endDate) {
      params.startDate = startDate;
      params.endDate = endDate;
    }
    if (this.sortBy) {
      params.sortBy = this.sortBy.active;
      params.sortDir = this.sortBy.direction;
    }
    this.isLoading = true;
    this.sellerService.getPointTransaction(params).subscribe(
      (data: any) => { this.isLoading = false; this.pointTransactionHistory = data; },
      (err: any) => { this.isLoading = false; this.pointTransactionHistory = ''; this.errors = err; }
    );
  }

  getpointTransactionHistory(pageNo: any) {
    this.size = pageNo.pageSize;
    this.pageNo = pageNo.pageIndex;
    const params: any = {
      userIds: this.userProfile.id,
      size: this.size,
      page: this.pageNo,
    };
    if (this.startDate && this.endDate) {
      params.startDate = this.startDate;
      params.endDate = this.endDate;
    }
    this.isLoading = true;
    this.sellerService.getPointTransaction(params).subscribe(
      (data: any) => { this.isLoading = false; this.pointTransactionHistory = data; },
      (err: any) => { this.isLoading = false; this.errors = err; }
    );
  }

  clearSearchPoints() {
    this.startDate = '';
    this.endDate = '';
    this.pthDateForm.reset();
    this.pageNo = 0;
    this.sortBy = null;
    this.getpointTransactionHistory({ pageSize: this.size, pageIndex: this.pageNo });
  }

  onPointsPageChange(page: number) {
    this.pointsPage = page;
    this.getpointTransactionHistory({ pageIndex: page - 1, pageSize: this.size });
  }

  downloadExcel() {
    const fileName = 'Point_Transaction_History_' + this.userProfile.company.id + '.xlsx';
    const url = sellerApi.pointTransactionHistory + '?userIds=' + this.userProfile.id + '&size=100000&excel=true';
    this.fileService.excelDownloadFile(url, fileName);
  }
}
